<div class="modal-header">
  <h4 class="modal-title h5" translate>Gateway</h4>
  <button (click)="onClose()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="table-responsive-md">
    <table class="table table-sm vertical-align-middle mb-0">
      <thead>
        <tr>
          <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="computedStatus">
            <span translate>Status</span>
          </th>
          <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="name" style="width:33%">
            <span translate>Name</span>
          </th>
          <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="id" style="width:33%">
            <span translate>Serial number</span>
          </th>
          <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="bqDataset">
            <span translate>BigQuery dataset</span>
          </th>
        </tr>
      </thead>
      <tbody>

        @for (cloudplug of gatewaysList; track cloudplug) {
          <tr>
            <td>
              <span [ngClass]="getStatusClass(cloudplug.computedStatus)" class="status"></span>
            </td>
            <td>
              <b>
                <ngb-highlight [result]="cloudplug.name" [term]="searchTerm"></ngb-highlight>
              </b>
            </td>
            <td>
              <ngb-highlight [result]="cloudplug.id" [term]="searchTerm"></ngb-highlight>
            </td>
            <td>
              <ngb-highlight [result]="cloudplug.bqDataset" [term]="searchTerm"></ngb-highlight>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <div class="modal-footer">
    <button (click)="onClose()" class="btn btn-primary" type="button">
      <span translate>Close</span>
    </button>
  </div>
</div>